import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    LocationAreas,
} from '../LocationAreas.types'

const locationAreasFields:DTOCardFormField<keyof LocationAreas>[] = [{
    id: 'generalInformation',
    title: 'General Information',
    className: 'generalInformation',
    fields: [
        {
            id: 'column1',
            fields: [{
                name: 'areaName',
                componentName: 'InputSingleline',
                labelKey: 'AREA_NAME',
            }],
        },
        {
            id: 'column2',
            fields: [
                {
                    name: 'latitude',
                    componentName: 'InputSingleline',
                    className: 'gatewayType',
                    labelKey: 'LATITUDE',
                },
                {
                    name: 'longitude',
                    componentName: 'InputSingleline',
                    labelKey: 'LONGITUDE',
                },
            ],
        },
        {
            id: 'column3',
            fields: [{
                name: 'description',
                componentName: 'LongText',
                labelKey: 'COMMENT',
            }],
        },
        {
            id: 'column4',
            fields: [{
                name: 'supportingDocuments',
                componentName: 'AttachmentsObjectSelector',
                labelKey: 'SUPPORTING_DOCUMENTS',
            }],
        },
    ],
}]

export default locationAreasFields
